export default __webpack_public_path__ + "static/media/supplino_logo_white.1b3f0925.png";